import type {
  AudioFileSource,
  UploadSource,
} from '@/features/media-file/domain/models/media-file'

export const isUploadSource = (
  source: AudioFileSource
): source is UploadSource =>
  source.kind === 'upload' && 'file' in source && source.file instanceof File
